import { useCallback, useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Button, Divider, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { Settings } from '../../../interfaces/Settings/Settings';
import { getSettingsByType, upsertSettings } from '../../../api/Settings';
import { SettingsType } from '../../../interfaces/Settings/SettingsType';
import { GenericSettingsValue } from '../../../interfaces/Settings/GenericSettingsValue';
import { getSettingsValue, getUpdatedSettings } from '../../../utils/Settings';
import { Waiting } from '../../../components/Waiting/Waiting';
import { sharedStyles } from '../../../utils/Style';
import { SettingsRow } from '../../../components/Settings/SettingsRow';
import { SettingsValueType } from '../../../interfaces/Settings/SettingsValueType';
import { allowedLanguages } from '../../../constants/Translation';

const localizationKeys = ['available_locales', 'default_locale'];

export const LocalizationSettings = () => {
  const [settings, setSettings] = useState<Settings[]>([]);
  const [loading, setLoading] = useState(true);

  const refreshSettings = () => {
    setLoading(true);
    getSettingsByType(SettingsType.FRONTEND)
      .then((s) => setSettings(s))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshSettings();
  }, []);

  const handleChange = useCallback(
    (key: string, newValue: GenericSettingsValue) =>
      setSettings(
        getUpdatedSettings(SettingsType.FRONTEND, key, settings, newValue),
      ),
    [settings],
  );

  const handleSave = () => {
    setLoading(true);
    upsertSettings(settings.filter((s) => localizationKeys.includes(s.key)))
      .then(() => {
        toast.success('Ayarlar başarıyla kaydedildi');
        refreshSettings();
      })
      .catch((err) => {
        toast.error(err.message);
        setLoading(false);
      });
  };

  return (
    <Grid container spacing={2}>
      <Waiting open={loading} />
      <Grid size={{ xs: 12, xl: 6 }}>
        <Paper
          sx={{
            p: 1.5,
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
            height: '95%',
          }}
        >
          <Typography
            sx={{
              ...sharedStyles.h5,
              fontWeight: 'bold',
            }}
          >
            Lokalizasyon
          </Typography>
          <Divider />

          <SettingsRow
            name='Dil Seçenekleri'
            valueType={SettingsValueType.MULTISELECT}
            options={allowedLanguages.map((language) => ({
              label: language.name,
              value: language.locale,
            }))}
            value={getSettingsValue(settings, 'available_locales')}
            onChange={(newValue) => handleChange('available_locales', newValue)}
          />
          <SettingsRow
            name='Varsayılan Dil'
            valueType={SettingsValueType.SELECT}
            options={allowedLanguages.map((language) => ({
              label: language.name,
              value: language.locale,
            }))}
            value={getSettingsValue(settings, 'default_locale')}
            onChange={(newValue) => handleChange('default_locale', newValue)}
          />

          <Box sx={{ display: 'flex', flexGrow: 1 }} />
          <Box display='flex' justifyContent='flex-end'>
            <Button
              variant='contained'
              onClick={handleSave}
              sx={{ ...sharedStyles.buttonText, mt: 1.5 }}
            >
              Kaydet
            </Button>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};
